var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodbeverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207,
    height: 209.438,
    viewBox: "0 0 207 209.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Food_beverage",
    "data-name": "Food & beverage",
    transform: "translate(-15.999 -10.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M215.559,324.359l-2.912-5.825v-46.67l3.086-6.172a3.45,3.45,0,0,0-3.086-4.993h-41.4a3.45,3.45,0,0,0-3.086,4.993l3.086,6.172v46.67l-2.132,4.265h-4.768V293.838a10.315,10.315,0,0,0-1.738-5.741l-5.741-8.612A3.45,3.45,0,0,0,154,277.95h-6.9v-6.9h-6.9v6.9h-6.9a3.45,3.45,0,0,0-2.87,1.536l-5.741,8.611a10.316,10.316,0,0,0-1.739,5.741V322.8h-6.9V300.738A10.315,10.315,0,0,0,114.31,295l-2.795-4.192A3.437,3.437,0,0,0,112.6,288.3v-6.9a10.362,10.362,0,0,0-10.35-10.35h-20.7A10.362,10.362,0,0,0,71.2,281.4v6.9a3.437,3.437,0,0,0,1.083,2.506L69.488,295a10.316,10.316,0,0,0-1.739,5.741V322.8h-6.9v-38.63a23.917,23.917,0,0,0-4.029-13.308,17.036,17.036,0,0,1-2.87-9.48V243.45A3.45,3.45,0,0,0,50.5,240H36.7a3.45,3.45,0,0,0-3.45,3.45v17.93a17.037,17.037,0,0,1-2.87,9.481,23.917,23.917,0,0,0-4.029,13.308v39.067A13.8,13.8,0,0,0,29.8,350.4H209.2a13.8,13.8,0,0,0,6.362-26.039ZM62.705,329.7a13.75,13.75,0,0,0,0,13.8H41.742a13.75,13.75,0,0,0,0-13.8Zm5.043,6.9a6.9,6.9,0,1,1,6.9,6.9A6.9,6.9,0,0,1,67.749,336.6Zm18.843-6.9h20.963a13.75,13.75,0,0,0,0,13.8H86.592a13.75,13.75,0,0,0,0-13.8Zm26.006,6.9a6.9,6.9,0,1,1,6.9,6.9A6.9,6.9,0,0,1,112.6,336.6Zm18.843-6.9H152.4a13.75,13.75,0,0,0,0,13.8H131.441a13.75,13.75,0,0,0,0-13.8Zm26.006,6.9a6.9,6.9,0,1,1,6.9,6.9,6.9,6.9,0,0,1-6.9-6.9Zm18.843-6.9h20.963a13.75,13.75,0,0,0,0,13.8H176.291a13.75,13.75,0,0,0,0-13.8Zm1.492-60.192-.954-1.907h30.235l-.953,1.907a3.448,3.448,0,0,0-.364,1.543v48.3a3.449,3.449,0,0,0,.364,1.543l.953,1.907H176.83l.953-1.907a3.448,3.448,0,0,0,.364-1.543v-48.3a3.448,3.448,0,0,0-.364-1.543Zm-47.935,24.332a3.44,3.44,0,0,1,.579-1.914l4.717-7.075h17.007l4.717,7.076a3.439,3.439,0,0,1,.579,1.913V322.8h-27.6ZM78.1,281.4a3.454,3.454,0,0,1,3.45-3.45h20.7a3.454,3.454,0,0,1,3.45,3.45v3.45H78.1Zm-3.45,19.339a3.44,3.44,0,0,1,.579-1.914l4.717-7.075h23.907l4.717,7.076a3.439,3.439,0,0,1,.579,1.913V322.8h-34.5Zm-41.4-16.569a17.037,17.037,0,0,1,2.87-9.48,23.917,23.917,0,0,0,4.029-13.308V246.9h6.9v14.48a23.917,23.917,0,0,0,4.029,13.308,17.037,17.037,0,0,1,2.87,9.48V322.8h-20.7ZM22.9,336.6a6.9,6.9,0,1,1,6.9,6.9A6.9,6.9,0,0,1,22.9,336.6Zm186.3,6.9a6.9,6.9,0,1,1,6.9-6.9,6.9,6.9,0,0,1-6.9,6.9Z",
    transform: "translate(0 -130.618)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_752",
    "data-name": "Rectangle 752",
    width: 13.8,
    height: 6.9,
    transform: "translate(185.047 154.231)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_753",
    "data-name": "Rectangle 753",
    width: 13.8,
    height: 6.9,
    transform: "translate(136.748 168.031)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_754",
    "data-name": "Rectangle 754",
    width: 13.8,
    height: 6.9,
    transform: "translate(84.998 171.481)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_755",
    "data-name": "Rectangle 755",
    width: 6.9,
    height: 13.8,
    transform: "translate(40.149 154.231)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_756",
    "data-name": "Rectangle 756",
    width: 6.9,
    height: 6.9,
    transform: "translate(147.098 36.932)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    width: 6.9,
    height: 6.9,
    transform: "translate(160.898 50.732)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    width: 6.9,
    height: 6.9,
    transform: "translate(147.098 50.732)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M68.249,88.228a10.374,10.374,0,0,0,7.326,8.465l52.663,15.489L133,126.455a10.337,10.337,0,0,0,9.819,7.077h10.753a10.337,10.337,0,0,0,9.819-7.077l4.757-14.272,52.663-15.489a10.374,10.374,0,0,0,7.326-8.466l1.7-11.882a10.35,10.35,0,0,0-10.246-11.813h-10.42a25.365,25.365,0,0,0,.824-36.219l6.192-6.192L211.3,17.243l-6.191,6.191a25.393,25.393,0,0,0-40.662,7.316,32.521,32.521,0,0,0-8.591-15.181,3.45,3.45,0,0,0-4.879,0L130.726,35.821a20.443,20.443,0,0,0-5.273-12.67l7.929-7.929L128.5,10.343l-8.515,8.515a20.551,20.551,0,0,0-24.26,3.56A32.682,32.682,0,0,0,86.092,45.68v.174l-.715.714a15.662,15.662,0,0,0-2.984,17.964H76.8A10.35,10.35,0,0,0,66.552,76.346Zm100.642-46.59A18.51,18.51,0,0,1,196.6,25.582l-11.744,4.7,2.562,6.406L201.874,30.9l-8.143,10.858,5.52,4.14,7.777-10.369a18.506,18.506,0,0,1-15.243,29H172.341a3.454,3.454,0,0,1-3.45-3.45Zm-37.523,3.3,7.105,18.948a26.021,26.021,0,0,1-5.757.648,25.63,25.63,0,0,1-15.66-5.285ZM144.938,61.47l-6.683-17.821,18.451,4.613A25.907,25.907,0,0,1,144.937,61.47Zm8.318-38.42a25.826,25.826,0,0,1,5.115,18.515l-18.9-4.726Zm-63,28.4,1.725-1.725a3.45,3.45,0,0,0,1.01-2.439v-1.6A25.826,25.826,0,0,1,100.607,27.3a13.626,13.626,0,1,1,19.27,19.271l-17.25,17.25a8.747,8.747,0,1,1-12.37-12.371ZM74.192,72.622a3.4,3.4,0,0,1,2.606-1.19h12.27A15.677,15.677,0,0,0,107.507,68.7l4.583-4.583a32.7,32.7,0,0,0,49.9-10.8v7.765a10.362,10.362,0,0,0,10.35,10.35h47.244A3.45,3.45,0,0,1,223,75.37l-1.7,11.882a3.457,3.457,0,0,1-2.442,2.822l-54.393,16a3.45,3.45,0,0,0-2.3,2.219l-5.327,15.982a3.445,3.445,0,0,1-3.273,2.359H142.815a3.445,3.445,0,0,1-3.273-2.359l-5.327-15.982a3.45,3.45,0,0,0-2.3-2.219l-54.393-16a3.457,3.457,0,0,1-2.442-2.822l-1.7-11.882a3.4,3.4,0,0,1,.809-2.748Z",
    transform: "translate(-28.693 0)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M228.461,186.259l-3.451,3.451,4.879,4.879,3.451-3.451a10.283,10.283,0,0,0,1.01.418V195.6h6.9v-4.043a10.282,10.282,0,0,0,1.009-.418l3.451,3.451,4.879-4.879-3.451-3.451a10.279,10.279,0,0,0,.418-1.009H251.6v-6.9h-4.043a10.282,10.282,0,0,0-.418-1.009l3.451-3.451-4.879-4.879-3.451,3.451a10.286,10.286,0,0,0-1.009-.418V168h-6.9v4.043a10.281,10.281,0,0,0-1.009.418l-3.451-3.451-4.879,4.879,3.451,3.451a10.279,10.279,0,0,0-.418,1.009H224v6.9h4.043A10.274,10.274,0,0,0,228.461,186.259Zm5.889-4.46a3.45,3.45,0,1,1,3.45,3.45,3.45,3.45,0,0,1-3.45-3.45Z",
    transform: "translate(-118.302 -89.668)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M199.109,182.158a21.009,21.009,0,0,1-.21-2.961,20.568,20.568,0,0,1,3.709-11.826l-5.659-3.948A27.438,27.438,0,0,0,192,179.2a27.857,27.857,0,0,0,.28,3.941Z",
    transform: "translate(-100.102 -87.065)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M298.9,182.158l6.83.978a27.853,27.853,0,0,0,.279-3.939,27.438,27.438,0,0,0-4.949-15.773l-5.659,3.947A20.574,20.574,0,0,1,299.11,179.2a21.017,21.017,0,0,1-.21,2.962Z",
    transform: "translate(-158.912 -87.065)",
    fill: "#1c6bfe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodbeverage);
export default __webpack_public_path__ + "static/media/Food & beverage.beda5c855a4328568ba15289cbcc187d.svg";
export { ForwardRef as ReactComponent };